import definition from './translation.service';

export default {
    name: 'TranslationService',
    definition
};



// WEBPACK FOOTER //
// ./app/services/translation/index.js